module.exports = __webpack_public_path__ + "assets/img/DS-kitchen (8).7e6f7687.jpg";